import { PayloadAction, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IResponseWithPagination } from "src/@types/api";
import { IInquiry } from "src/@types/inquiries";
import {
  getWatchlistAsync,
  removeFromWatchlistAsync,
} from "./actions";
import { WatchlistState } from "./slice";

type ActionReducerMapBuilderWithWatchlistState =
  ActionReducerMapBuilder<WatchlistState>;

export const getWatchlistReducer = (
  builder: ActionReducerMapBuilderWithWatchlistState,
) => {
  builder.addCase(getWatchlistAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(getWatchlistAsync.fulfilled,
    (state, action: PayloadAction<IResponseWithPagination<IInquiry>>) => {
      state.isLoading = false;
      state.items = action.payload;
    }
  );

  builder.addCase(getWatchlistAsync.rejected, (state) => {
    state.isLoading = false;
    state.items = null
  });
}

export const removeFromWatchlistReducer = (
  builder: ActionReducerMapBuilderWithWatchlistState,
) => {
  builder.addCase(removeFromWatchlistAsync.fulfilled,
    (state, action: PayloadAction<number>) => {
      const deletedCloneId = action.payload;

      // CHANGE
      if (state.items && state.items.results) {
        state.items.results = state.items.results.filter(
          ({ id }) => deletedCloneId !== id
        );
      }
    }
  );
}